import { render } from "./LeaveCommentsModal.vue?vue&type=template&id=3cdf3e1a&scoped=true"
import script from "./LeaveCommentsModal.vue?vue&type=script&lang=js"
export * from "./LeaveCommentsModal.vue?vue&type=script&lang=js"

import "./leave-comment-modal.scss?vue&type=style&index=0&id=3cdf3e1a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdf3e1a"]])

export default __exports__